import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BakeasySnackbarReduxProp } from '../../components/snackbars/BakeasySnackBarRedux';
import { NO_DATA_FOUND } from '../../constants/Constants';
import { t } from 'i18next';

const initialState: BakeasySnackbarReduxProp = {
  open: false,
  message: '',
  severity: 'info'
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSuccessSnackbar(state, action: PayloadAction<BakeasySnackbarReduxProp>) {
      state.open = true;
      state.message = getMessage(action.payload.message);
      state.severity = 'success';
    },
    showErrorSnackbar(state, action: PayloadAction<BakeasySnackbarReduxProp>) {
      state.open = true;
      state.message = getMessage(action.payload.message);
      state.severity = 'error';
    },
    hideSnackbar(state) {
      state.open = false;
      state.message = '';
      state.severity = 'info';
    }
  }
});

function getMessage(err: any) {
  let message = '';
  if (err?.response?.data?.error) {
    message = JSON.stringify(err?.response?.data?.error);
  } else if (err?.response?.data) {
    message = JSON.stringify(err?.response?.data);
  } else if (err?.data) {
    message = JSON.stringify(err?.data);
  } else if (err?.message) {
    message = JSON.stringify(err?.message);
  } else if (err?.error?.error) {
    message = JSON.stringify(err?.error?.error);
  } else if (err?.error) {
    message = JSON.stringify(err?.error);
  } else {
    message = err;
  }

  if (message == '{}') {
    message = NO_DATA_FOUND;
  }
  return t(message);
}

export const { hideSnackbar, showSuccessSnackbar, showErrorSnackbar } = snackbarSlice.actions;

const snackbarReducer = snackbarSlice.reducer;
export default snackbarReducer;
